import { render, staticRenderFns } from "./BotaoAssinarDocumento.vue?vue&type=template&id=86d7cb60&scoped=true"
import script from "./BotaoAssinarDocumento.vue?vue&type=script&lang=js"
export * from "./BotaoAssinarDocumento.vue?vue&type=script&lang=js"
import style0 from "./BotaoAssinarDocumento.vue?vue&type=style&index=0&id=86d7cb60&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d7cb60",
  null
  
)

export default component.exports